module.exports = {
  "dof-step-action": {
    "flexDirection": "row"
  },
  "dof-step-action-container": {
    "flex": 1,
    "paddingLeft": "16",
    "paddingRight": "16"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-0f329774!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-step-action/index.vue
// module id = 419
// module chunks = 0 1